













import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class Select extends Vue {
  name = "select"
  @Prop() onChangeFunc
  @Prop() options: Array<any>
}
